import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IdName} from '../../models/id-name.model';
import {ValidationService} from '../../services/validation.service';
import {NgModel} from '@angular/forms';

@Component({
  selector: 'si-check-dynamic',
  templateUrl: './check-dynamic.component.html',
  styleUrls: ['./check-dynamic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckDynamicComponent {
  @Input() text: string;
  @Input() styleClass: string;
  @Input() styleClassCheck: string;
  @Input() id: string;
  @Input() vertical = false;
  @Input() valueAttr: string;
  @Input() disabled: boolean;
  @Input() rule: string;
  @Input() validationExternalErrorText: string;
  @Input() tooltipText: string;
  @Input() tooltipPosition: string;
  @Input() tooltipIcon: string;
  @Input() tooltipStyleClass: string;
  @Input() tooltipEscape = true;
  @Input() forceShowTooltipIcon: boolean;
  @Input() hideLabel = false;
  @Output() modelChange = new EventEmitter<any>();
  @Output() tooltipIconClick = new EventEmitter<any>();
  @Output() selectDefaultChange = new EventEmitter<any>();
  @ViewChild('formModel') formModel: NgModel;
  options: IdName[];
  checkModel: boolean[];
  showRuleErrorOutsideIcon: boolean;
  validationErrorText: string;
  private _path: string;
  private _values: IdName[];
  private _model: any[];
  private _selectDefault = false;

  constructor(
    private http: HttpClient,
    private validationService: ValidationService
  ) {
    this.setLogic();
  }

  get model(): any[] {
    return this._model;
  }

  @Input()
  set model(val) {
    this._model = val || [];
    this.setCheckModel();
  }

  get path(): string {
    return this._path;
  }

  @Input()
  set path(val) {
    this._path = val;
    this.getOptions();
  }

  get values(): IdName[] {
    return this._values;
  }

  @Input()
  set values(val) {
    this._values = val;
    this.options = val;
    this.setCheckModel();
  }

  @Input()
  set selectSingle(val) {
    this.selectIfSingleOption();
  }

  get selectDefault(): boolean {
    return this._selectDefault;
  }

  @Input()
  set selectDefault(val) {
    this._selectDefault = val;
    if (val) {
      this.getOptions();
    }
  }

  setLogic(): void {
    this.showRuleErrorOutsideIcon = this.validationService.getShowRuleErrorOutsideIcon();
  }

  async getOptions(): Promise<void> {
    this.options = [];
    try {
      this.options = await this.http.get<IdName[]>(this.path).toPromise();
      this.setCheckModel();
    } catch (error) {
      console.error(error);
    }
  }

  setCheckModel(): void {
    if (!this.options?.length || !this.model) {
      return;
    }

    // Generate array of boolean to check or not the si-check components
    const defaultOptions = [];
    this.checkModel = this.options.map(option => {
      const optionId = option[this.valueAttr || 'id'];
      if (!this.model?.length && this.selectDefault && option.isDefault) {
        defaultOptions.push(option);
      };

      return this.model.some(item => {
        if (item instanceof Object) {
          return item[this.valueAttr || 'id'] === optionId;
        } else {
          return item === optionId;
        }
      });
    });

    if (defaultOptions.length) {
      const defaultOptionsParsed = this.valueAttr ? defaultOptions.map((val) => val[this.valueAttr]) : defaultOptions;
      this.selectDefaultChange.emit(defaultOptionsParsed);
    }
  }

  // Get the options and select the single one if there is only one option
  async selectIfSingleOption(): Promise<void> {
    await this.getOptions();
    if (this.options.length !== 1) {
      return;
    }

    this.model = [this.options[0]];
    const singleOptionParsed = this.valueAttr ? this.options[0][this.valueAttr] : this.options[0];
    this.selectDefaultChange.emit([singleOptionParsed]);
  }

  onChangeModel(checkModel: boolean, option: IdName): void {
    if (checkModel) {
      this.model = this.model.concat(this.valueAttr ? [option[this.valueAttr]] : [option]);
    } else {
      this.model = this.model.filter(item => (this.valueAttr ? item !== option[this.valueAttr] : item.id !== option.id));
    }

    this.formModel.control.markAsDirty();
    this.modelChange.emit(this.model);
  }

  onClickTooltipIcon(event: any): void {
    this.tooltipIconClick.emit(event);
  }
}
